import { render, staticRenderFns } from "./RecordContacts.vue?vue&type=template&id=5b66a13a&scoped=true&"
import script from "./RecordContacts.vue?vue&type=script&lang=js&"
export * from "./RecordContacts.vue?vue&type=script&lang=js&"
import style0 from "./RecordContacts.vue?vue&type=style&index=0&id=5b66a13a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66a13a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
